import './abstract_section_view.coffee'
Namespace('Monitoring.Reports.Executive')

class Monitoring.Reports.Executive.ShareOfVoiceView extends Monitoring.Reports.Executive.AbstractSectionView
  id: 'share'
  name: 'share'
  tagName: 'section'
  template: JST["backbone/templates/monitoring/reports/executive/share_of_voice"]

  initialize: (@options = {}) ->
    @colors = {}
    @colors[@options.settings.accountLabel.codes[0]] = @options.settings.accountLabel.color
    $.each @options.settings.competitorsLabels, (index, label) =>
      @colors[label.codes[0]] = label.color

  render: ->
    @bindChartsReady(1)
    sections = @_colorsByBrands()
    @$el.html(@template(sections:sections))
    @addShareOfVoicePie('#share-of-voice-pie')
    return this

  addShareOfVoicePie: (divId)->
    benchmark_query = @extendedQuery({
      dimension: 'filtered_labels'
      date_from_ISO: @options.fromBenchmark.toISOString()
      date_to_ISO: @options.toBenchmark.toISOString()
      labels: @labelFilter()
      labels_structure: @labelsStructure()
      must_be_public_comments: true
    })

    @$el.find(divId).addClass('processing')
    $.post(@options.chartApi.singleDimension, benchmark_query, (response) =>
      return unless response.series.length > 0

      @benchmark_response = response
      ISO_query = @labelsQuery(@labelFilter(), @labelsStructure())

      $.post(@options.chartApi.singleDimension, _.extend( {},ISO_query, must_be_public_comments: true) , (response) =>
        return unless response.series.length > 0

        new Highcharts.Chart(@singleDimensionOptions(response, divId, drillDownFunction: (clickEvent) ->
          {
            labels: [clickEvent.point.code]
          }
        ))
        @updateValues(response, @benchmark_response)
        @chartReady(divId)
      )
    )

  updateValues: (response, benchmark_response) ->
    values = {}
    total = 0
    for point in response.series[0].data
      values[point.code.toLowerCase()] = point.y
      total += point.y

    benchmark_values = {}
    for point in benchmark_response.series[0].data
      benchmark_values[point.code.toLowerCase()] = point.y

    $.each values, (key, value) =>
      percentage = @_percentage(value, total)
      variation =  Math.round((value - benchmark_values[key]) / benchmark_values[key] * 10000) / 100
      if variation >= 0
        variation_str = "<span class=\"variation up\">+#{variation}%</span>"
      else
        variation_str = "<span class=\"variation down\">#{variation}%</span>"

      $(document).find(".references."+key).find(".total").text(value)
      $(document).find(".references."+key).find(".percent").text(percentage+"%")
      $(document).find(".references."+key).find(".description").append variation_str + "  since last period"
    $(document).find(".repo-header").find(".num").text(total)

  singleDimensionOptions: (response, divId, options={}) ->
    series = response.series
    series[0].type = 'pie'
    series[0].events = {
      click: (evt) => @openDrillDown(options.drillDownFunction(evt))
    }
    for point in series[0].data
      point.color = @colors[point.code]
    {
    chart:
      backgroundColor: null
      renderTo: $(divId)[0]
      width: 246
      height: 246
    series: series
    plotOptions:
      pie:
        dataLabels:
          enabled: false
        innerSize: 75
    exporting:
      enabled: false
    title:
      text: null
    }
